import {
  individualStorePerformanceConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { individualStorePerformanceService } from "../../services";
import {
  success,
  withSpinner,
  failure,
} from "../../../../redux/actions/utilities";

const {
  ALL_USER_RESPONSE_DATA,
  GET_CUSTOMER_CONVERSATIONS,
  RESET_CUSTOMER_CONVERSATION,
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
} = individualStorePerformanceConstants;

//Get all user responses
const getAllUserResponses = (body, locationId, frRoute, fromDate, toDate) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_USER_RESPONSE_DATA, () =>
      individualStorePerformanceService
        .getAllUserResponses(body, locationId, frRoute, fromDate, toDate)
        .then(
          (response) => {
            dispatch(success(response, ALL_USER_RESPONSE_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          },
        )
    );
  };
};

const getAllUserResponsesItemsForExport = (
  body,
  locationId,
  frRoute,
  fromDate,
  toDate,
) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_USER_RESPONSE_DATA, () =>
      individualStorePerformanceService
        .getAllUserResponses(body, locationId, frRoute, fromDate, toDate)
        .then(
          (response) => {
            dispatch(
              success(
                response.pageData.userResponses,
                CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
              ),
            );
          },
          (error) => {
            dispatch(resetAllExportItems());
            customToast(error, toastTypes.ERROR);
          },
        )
    );
  };
};

const resetAllExportItems = () => {
  return (dispatch) => {
    dispatch(failure([], CUSTOMER_RESPONSES_EXPORT_ALL_DATA));
  };
};

const getCustomerConversationsNotes = (data, body) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_CUSTOMER_CONVERSATIONS, () =>
      individualStorePerformanceService
        .getCustomerConversationNotes(data, body)
        .then(
          (response) => {
            dispatch(success(response, GET_CUSTOMER_CONVERSATIONS));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          },
        )
    );
  };
};

const resetCustomerConversations = () => (dispatch) => {
  dispatch(success([], RESET_CUSTOMER_CONVERSATION));
};

export const individualStorePerformanceActions = {
  getAllUserResponses,
  resetAllExportItems,
  resetCustomerConversations,
  getCustomerConversationsNotes,
  getAllUserResponsesItemsForExport,
};
